/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserSegmentsDisplayOrderQueryVariables = GraphQL.Exact<{
  legacyUserId: GraphQL.Scalars['ID']['input'];
}>;


export type UserSegmentsDisplayOrderQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly segmentsDisplayOrder: ReadonlyArray<{ readonly __typename?: 'SegmentIdentifier', readonly color: string, readonly iconName: string | null, readonly label: string, readonly shortcode: string | null }> | null } | null };


export const UserSegmentsDisplayOrderDocument = gql`
    query UserSegmentsDisplayOrder($legacyUserId: ID!) {
  user(legacyId: $legacyUserId) {
    id
    legacyId
    segmentsDisplayOrder {
      color
      iconName
      label
      shortcode
    }
  }
}
    `;

/**
 * __useUserSegmentsDisplayOrderQuery__
 *
 * To run a query within a React component, call `useUserSegmentsDisplayOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSegmentsDisplayOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSegmentsDisplayOrderQuery({
 *   variables: {
 *      legacyUserId: // value for 'legacyUserId'
 *   },
 * });
 */
export function useUserSegmentsDisplayOrderQuery(baseOptions: Apollo.QueryHookOptions<UserSegmentsDisplayOrderQuery, UserSegmentsDisplayOrderQueryVariables> & ({ variables: UserSegmentsDisplayOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSegmentsDisplayOrderQuery, UserSegmentsDisplayOrderQueryVariables>(UserSegmentsDisplayOrderDocument, options);
      }
export function useUserSegmentsDisplayOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSegmentsDisplayOrderQuery, UserSegmentsDisplayOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSegmentsDisplayOrderQuery, UserSegmentsDisplayOrderQueryVariables>(UserSegmentsDisplayOrderDocument, options);
        }
export function useUserSegmentsDisplayOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserSegmentsDisplayOrderQuery, UserSegmentsDisplayOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSegmentsDisplayOrderQuery, UserSegmentsDisplayOrderQueryVariables>(UserSegmentsDisplayOrderDocument, options);
        }
export type UserSegmentsDisplayOrderQueryHookResult = ReturnType<typeof useUserSegmentsDisplayOrderQuery>;
export type UserSegmentsDisplayOrderLazyQueryHookResult = ReturnType<typeof useUserSegmentsDisplayOrderLazyQuery>;
export type UserSegmentsDisplayOrderSuspenseQueryHookResult = ReturnType<typeof useUserSegmentsDisplayOrderSuspenseQuery>;
export type UserSegmentsDisplayOrderQueryResult = Apollo.QueryResult<UserSegmentsDisplayOrderQuery, UserSegmentsDisplayOrderQueryVariables>;